import {createAsyncThunk} from '@reduxjs/toolkit'

import {MERCHANDISER_LIST} from '@web/core/urls'
import {changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryParam, ThunkApi} from '../interfaces'

/**
 * 결제사용처 목록 페이지로 이동
 */
const navigateToTermsPolicyMerchandiserList = createAsyncThunk<void, LocationChangeHistoryParam | void, ThunkApi>(
    'navigateTo/termsPolicyMerchandiserList',
    async (args) => {
        const {historyType = 'PUSH'} = args ?? {}

        changeBrowserLocation({url: MERCHANDISER_LIST, type: historyType})
    },
)

export default navigateToTermsPolicyMerchandiserList
